"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGasAmountForMessage = exports.getEncodeObjectFromMultiChainMessageInjective = exports.getEncodeObjectFromMultiChainMessage = void 0;
const encoding_1 = require("@cosmjs/encoding");
const MsgTransfer_1 = __importDefault(require("@injectivelabs/sdk-ts/dist/cjs/core/modules/ibc/msgs/MsgTransfer"));
const MsgExecuteContract_1 = __importDefault(require("@injectivelabs/sdk-ts/dist/cjs/core/modules/wasm/msgs/MsgExecuteContract"));
const tx_1 = require("cosmjs-types/cosmos/bank/v1beta1/tx");
const tx_2 = require("cosmjs-types/cosmwasm/wasm/v1/tx");
const tx_3 = require("cosmjs-types/ibc/applications/transfer/v1/tx");
function getEncodeObjectFromMultiChainMessage(message) {
    const msgJson = JSON.parse(message.msg);
    if (message.msgTypeURL === "/ibc.applications.transfer.v1.MsgTransfer") {
        return {
            typeUrl: "/ibc.applications.transfer.v1.MsgTransfer",
            value: tx_3.MsgTransfer.fromJSON({
                sourcePort: msgJson.source_port,
                sourceChannel: msgJson.source_channel,
                token: msgJson.token,
                sender: msgJson.sender,
                receiver: msgJson.receiver,
                timeoutHeight: msgJson.timeout_height,
                timeoutTimestamp: msgJson.timeout_timestamp,
                memo: msgJson.memo,
            }),
        };
    }
    if (message.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract") {
        return {
            typeUrl: message.msgTypeURL,
            value: tx_2.MsgExecuteContract.fromPartial({
                sender: msgJson.sender,
                contract: msgJson.contract,
                msg: (0, encoding_1.toUtf8)(JSON.stringify(msgJson.msg)),
                funds: msgJson.funds,
            }),
        };
    }
    if (message.msgTypeURL === "/cosmos.bank.v1beta1.MsgSend") {
        return {
            typeUrl: message.msgTypeURL,
            value: tx_1.MsgSend.fromPartial({
                fromAddress: msgJson.from_address,
                toAddress: msgJson.to_address,
                amount: msgJson.amount,
            }),
        };
    }
    return {
        typeUrl: message.msgTypeURL,
        value: msgJson,
    };
}
exports.getEncodeObjectFromMultiChainMessage = getEncodeObjectFromMultiChainMessage;
function getEncodeObjectFromMultiChainMessageInjective(message) {
    const msgJson = JSON.parse(message.msg);
    if (message.msgTypeURL === "/ibc.applications.transfer.v1.MsgTransfer") {
        return MsgTransfer_1.default.fromJSON({
            port: msgJson.source_port,
            channelId: msgJson.source_channel,
            amount: msgJson.token,
            sender: msgJson.sender,
            receiver: msgJson.receiver,
            timeout: msgJson.timeout_timestamp,
            memo: msgJson.memo,
        });
    }
    if (message.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract") {
        return MsgExecuteContract_1.default.fromJSON({
            sender: msgJson.sender,
            contractAddress: msgJson.contract,
            msg: (0, encoding_1.toUtf8)(JSON.stringify(msgJson.msg)),
            funds: msgJson.funds,
        });
    }
    throw new Error("Unsupported message type");
}
exports.getEncodeObjectFromMultiChainMessageInjective = getEncodeObjectFromMultiChainMessageInjective;
function getGasAmountForMessage(message) {
    if (message.msgTypeURL === "/cosmwasm.wasm.v1.MsgExecuteContract") {
        if (message.chainID === "neutron-1") {
            return "2400000";
        }
        return "2000000";
    }
    return "280000";
}
exports.getGasAmountForMessage = getGasAmountForMessage;
//# sourceMappingURL=transactions.js.map